import { FirebaseDocRefType } from 'firebase/index'
import { StockUnionType } from 'types/stock'
import { StoreDefaultScheduleType } from 'types/storeDefault'

const getInitialStoreDefaultSchedule = (
  storeDefaultBreadRef: FirebaseDocRefType,
  scheduleRef: FirebaseDocRefType,
  type: StockUnionType,
  defaultSchedule?: StoreDefaultScheduleType
): StoreDefaultScheduleType => {
  return {
    store_default_bread_ref: storeDefaultBreadRef,
    choices: defaultSchedule?.choices ?? [],
    days_of_week: [],
    default_stocks: [{ pickupable_time: '', stock: 0 }],
    hours_to_deadline: defaultSchedule?.hours_to_deadline ?? 12,
    maximum_order: defaultSchedule?.maximum_order ?? 1,
    note: defaultSchedule?.note ?? '',
    options: defaultSchedule?.options ?? [],
    schedule_ref: scheduleRef,
    type: type,
  }
}

export default getInitialStoreDefaultSchedule
